<ng-container *ngIf="worksheets$ | withLoading | async as worksheets">
  <ng-container *ngIf="worksheets.data">
    <div class="text-white video-container">
      <div *ngIf="currentItem && currentItem.WorksheetType === worksheetType.ProviderVideo"
        class="container pb-4 worksheet-container">
        <!-- Left side - Main Player -->
        <div class="mt-30 player-section">
          <div class="worksheet-wrapper" [ngClass]="{ 'single-worksheetitem': isWorksheetItems }">
            <ng-container #outlet [ngTemplateOutlet]="content"></ng-container>
            <ng-template #content>
              <fgb-benefits-worksheet-item [worksheetItem]="currentItem" [worksheetId]="worksheetId"></fgb-benefits-worksheet-item>
              <div class="worksheet-details">
                <h3 class="font-page-heading text-uppercase">{{ currentItem.Title }}</h3>
                <p class="font-size-14">{{ currentItem.Description }}</p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Right side - Playlist -->
        <ng-container *ngFor="let worksheetGroup of worksheets.data; trackBy: trackByWorksheetId">
          <ng-container *ngIf="hasWorksheetType(worksheetGroup.Items, worksheetType.ProviderVideo)">
            <div class="playlist-section">
              <div [class.row]="isList" class="flex-lg-wrap flex-nowrap">
                <ng-container *ngFor="let item of worksheetGroup.Items; trackBy: trackByItemId">
                  <ng-container *ngIf="item.WorksheetType === worksheetType.ProviderVideo">
                    <div class="worksheet-item me-4 mb-3" [class.active]="item.Id === currentItem.Id"
                      (click)="selectWorksheetItem(item)">
                      <div class="thumbnail-container">
                        <div class="thumbnail position-relative">
                          <img [src]="item.Image | contentImage : '7'" [alt]="item.Title" />
                          <div class="playing-overlay">
                            <span class="">{{ 'worksheet.now.playing.text' | translate }}</span>
                          </div>
                          <div class="overlay">
                            <span class="icon material-icons play-button">play_circle</span>
                          </div>
                        </div>
                        <div class="worksheet-info">
                          <h6 class="font-size-14 font-bold">{{ item.Title }}</h6>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="container" [ngClass]="{'px-0':currentPage == 'benefits'}">
      <ng-container *ngFor="let worksheetGroup of worksheets.data; trackBy: trackByWorksheetId">
        <ng-container *ngIf="worksheetGroup.Items?.length && worksheetGroup.Items[0].WorksheetType == worksheetType.Gallery">
          <span [ngClass]="{'d-none':currentPage == 'benefits'}"
            class="d-flex text-start font-size-20 font-page-heading mt-3">
            {{ 'worksheet.gallery.images' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="worksheetGroup.Items?.length > 0">
          <div [class.row]="isList">
            <ng-container *ngFor="let item of worksheetGroup.Items; trackBy: trackByItemId">
              <ng-container *ngIf="item.WorksheetType == worksheetType.Download">
                <div [class.col-lg-4]="isList">
                  <fgb-benefits-worksheet-item [worksheetItem]="item"
                    [worksheetId]="worksheetGroup.WorksheetId"></fgb-benefits-worksheet-item>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <div [class.row]="isList">
          <ng-container *ngFor="let item of worksheetGroup.Items; trackBy: trackByItemId">
            <ng-container
              *ngIf="item.WorksheetType == worksheetType.Gallery || item.WorksheetType == worksheetType.Link">
              <div [ngClass]="{'col-6':currentPage == 'gallery'}" [class.col-lg-4]="isList">
                <fgb-benefits-worksheet-item [worksheetItem]="item"
                  [worksheetId]="worksheetGroup.WorksheetId"></fgb-benefits-worksheet-item>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- No Data available -->
  <ng-container *ngIf="worksheets.isEmpty">
    <p>No worksheet available</p>
  </ng-container>

  <!-- Error -->
  <ng-container *ngIf="worksheets.error">
    <p>Error {{ worksheets.error }}</p>
  </ng-container>

  <!-- Loading -->
  <ng-container *ngIf="worksheets.isLoading">
    <div class="w-100">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-container>
</ng-container>